import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ASwitch from '@/components/atoms/ASwitch.vue'
	import AInputText from '@/components/atoms/AInputText.vue'
	import AInputNumber from '@/components/atoms/AInputNumber.vue'
	import AInputAutocomplete from '@/components/atoms/AInputAutocomplete.vue'
	import AInputCombobox from '@/components/atoms/AInputCombobox.vue'
	// import AInputTextArea from '@/components/atoms/AInputTextArea.vue'
	import MSelectCustomer from '@/components/molecules/MSelectCustomer.vue'
	import MSelectActionDefinition from '@/components/molecules/MSelectActionDefinition.vue'
	import MSelectGroup from '@/components/molecules/MSelectGroup.vue'
	// import MSelectIssue from '@/components/molecules/MSelectIssue.vue'
	import MSelectMachine from '@/components/molecules/MSelectMachine.vue'
	import MSelectPerson from '@/components/molecules/MSelectPerson.vue'
	import MSelectRole from '@/components/molecules/MSelectRole.vue'

	import type { ObjectContext } from '@/global'
	import type { ComputedRef } from 'vue'
	import { reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		modelValue: { type: [Array, Object, String, Number, Boolean], default: null },
		keyName: { type: String, default: '', required: true },
		tabSelected: { type: String, default: '', required: true },
		cellEditor: { type: Boolean, default: false },
		allowedIds: { type: Array, default: () => [] },
		customerIds: { type: Array, default: () => [] }
	},
  emits: ['update:modelValue', 'input', 'change', 'blur', 'clear', 'enter'],
  setup(__props, { emit: $emit }) {

const $props = __props

	const { $store } = useGeneral()

	
	

	const state = reactive({
		item: null
	})

	watch(
		() => $props.modelValue,
		val => {
			// @ts-ignore
			state.item = val
			// if (val !== state.item) state.item = val
		}
	)

	function init() {
		// @ts-ignore
		state.item = typeof $props.modelValue === 'boolean' ? $props.modelValue : $props.modelValue || {}
	}
	init()

	const dictionaryItem: ComputedRef<ObjectContext> = computed(() => $store.state.dictionary.item_keys[$props.keyName] || {})
	const validation: ComputedRef<ObjectContext> = computed(() => dictionaryItem.value.validation || {})
	// @ts-ignore
	const type: ComputedRef<string> = computed(() => validation.value[$props.tabSelected]?.type || validation.value.default?.type || 'string')
	// @ts-ignore
	const required: ComputedRef<boolean> = computed(() => validation.value[$props.tabSelected]?.required || validation.value.default?.required || false)
	// @ts-ignore
	const multiple: ComputedRef<boolean> = computed(() => validation.value[$props.tabSelected]?.multiple || validation.value.default?.multiple || false)
	const disabled: ComputedRef<boolean> = computed(() => false)
	const loading: ComputedRef<boolean> = computed(() => false)
	// @ts-ignore
	const allowedValues: ComputedRef<Array<any>> = computed(() => {
		let allowed_values = $store.getters['dictionary/GET_ALLOWED_VALUES'][$props.keyName]
		return allowed_values || validation.value[$props.tabSelected]?.allowed_values || validation.value.default?.allowed_values || []
	})

	const component: ComputedRef = computed(() => {
		let selected: any = AInputText
		const keyName = $props.keyName
		if (['customer_id', 'customer_ids'].includes(keyName)) selected = MSelectCustomer
		else if (['action_definition_id', 'action_definition_ids'].includes(keyName)) selected = MSelectActionDefinition
		else if (['group_id', 'group_ids', 'default_group_id'].includes(keyName)) selected = MSelectGroup
		else if (['person_id', 'person_ids'].includes(keyName)) selected = MSelectPerson
		else if (['machine_id', 'machine_ids'].includes(keyName)) selected = MSelectMachine
		else if (['role'].includes(keyName)) selected = MSelectRole
		else if (allowedValues.value.length > 0) selected = AInputAutocomplete
		else if (type.value === 'list') selected = AInputCombobox
		else if (type.value === 'boolean') selected = ASwitch
		else if (['number', 'float'].includes(type.value)) selected = AInputNumber
		return selected
	})

	function onUpdateValue(val?: any) {
		const value = val || state.item
		$emit('update:modelValue', value)
	}
	function onInput(val: any) {
		onUpdateValue()
		$emit('input', val)
	}
	function onChange(val: any) {
		onUpdateValue(val)
		$emit('change', val)
	}
	function onBlur(val: any) {
		onUpdateValue()
		$emit('blur', val)
	}
	function onClear() {
		$emit('clear')
	}
	function onEnter() {
		$emit('enter')
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), {
    modelValue: _unref(state).item,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).item) = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (onUpdateValue($event)))
    ],
    "key-name": __props.keyName,
    items: _unref(allowedValues),
    required: _unref(required),
    disabled: _unref(disabled),
    multiple: _unref(multiple),
    loading: _unref(loading),
    "allowed-ids": __props.allowedIds,
    "customer-ids": __props.customerIds,
    "cell-editor": $props.cellEditor,
    onInput: _cache[2] || (_cache[2] = ($event: any) => (onInput($event))),
    onChange: _cache[3] || (_cache[3] = ($event: any) => (onChange($event))),
    onBlur: _cache[4] || (_cache[4] = ($event: any) => (onBlur($event))),
    onEnter: _cache[5] || (_cache[5] = ($event: any) => (onEnter($event))),
    onClear: _cache[6] || (_cache[6] = ($event: any) => (onClear()))
  }, null, 8, ["modelValue", "key-name", "items", "required", "disabled", "multiple", "loading", "allowed-ids", "customer-ids", "cell-editor"]))
}
}

})